import React from "react";

export default function TbodyListInhabitant({
  access,
  idsToDelete,
  inhabitantSegments,
  setIdsToDelete,
  format,
  setIsOpen,
  setIdToDelete,
}) {
  return inhabitantSegments.length > 0 ? (
    inhabitantSegments.map(({ customer, accessor, segment, place }, index) => (
      <tr key={index}>
        <td>{customer.name || "Não cadastrado"}</td>
        <td>{customer.cpf || "Não cadastrado"}</td>
        <td>{accessor.name || "Não cadastrado"}</td>
        <td>{segment.name || "Não cadastrado"}</td>
        <td>{place.name || "Não cadastrada"}</td>
        <td>{format(new Date(customer.date_entry), "dd/MM/yyyy")}</td>
        <td>
          {!customer.date_end
            ? "Ainda no segmento"
            : format(new Date(customer.date_end), "dd/MM/yyyy")}
        </td>
        {access && (
          <>
            <td>
              <button
                onClick={() => {
                  setIdToDelete(customer.id);
                  setIsOpen(true);
                }}
                className="button-add margin-bottom-20 btn-remove"
                disabled={!segment.current_segment || idsToDelete.length}
              >
                Remover
              </button>
            </td>

            <td>
              <input
                type="checkbox"
                className="checkbox"
                onChange={() => {
                  let ids = idsToDelete;

                  if (ids.includes(customer.id)) {
                    ids = ids.filter((id) => id !== customer.id);
                  } else {
                    ids = [...ids, customer.id];
                  }

                  setIdsToDelete(ids);
                }}
                checked={idsToDelete.includes(customer.id)}
              />
            </td>
          </>
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        Nenhum registro encontrado.
      </td>
    </tr>
  );
}
